<script lang="ts">
    
    import { Badge, Icon } from "sveltestrap";

    export let text = 'Desactivado';

</script>

<Badge color="danger">
    <Icon name="x" /> {text}
</Badge>
